import { useEffect, useState } from "react";
import { ShieldCheck, KeyRound, Database, ScrollText, Lock } from "lucide-react";
import api from "@/lib/api";

const card = "bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-2xl";

export default function Security() {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/admin/activity").then((r) => setLog(r.data)).catch(() => {}); }, []);

  const controls = [
    { icon: ShieldCheck, title: "Role-based permissions", desc: "Owner role active. Staff sub-roles coming soon.", status: "Active" },
    { icon: KeyRound, title: "Two-factor authentication", desc: "Add an extra step at login via authenticator app.", status: "Setup pending" },
    { icon: Database, title: "Automatic backups", desc: "Managed daily database snapshots.", status: "Managed" },
    { icon: Lock, title: "Audit history", desc: "Every admin action is recorded below.", status: "Active" },
  ];

  return (
    <div data-testid="security-page">
      <h1 className="font-display text-4xl">Security</h1>
      <p className="text-brand-ink/60 dark:text-white/50 mt-2">Access control, audit trail and account protection.</p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {controls.map((c) => (
          <div key={c.title} className={`${card} p-6`} data-testid={`security-${c.title.toLowerCase().split(" ")[0]}`}>
            <div className="flex items-center justify-between">
              <c.icon className="w-6 h-6 text-brand-red" />
              <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-brand-mist dark:bg-neutral-800">{c.status}</span>
            </div>
            <div className="mt-4 font-medium">{c.title}</div>
            <p className="text-sm text-brand-ink/60 dark:text-white/50 mt-1">{c.desc}</p>
          </div>
        ))}
      </div>

      <div className={`${card} mt-6 overflow-hidden`}>
        <div className="px-6 py-4 border-b border-brand-line dark:border-neutral-800 font-display text-xl flex items-center gap-2"><ScrollText className="w-5 h-5 text-brand-red" /> Activity log</div>
        {log.length === 0 ? <div className="p-6 text-brand-ink/50 dark:text-white/40" data-testid="activity-empty">No activity recorded yet.</div> : (
          <div className="divide-y divide-brand-line dark:divide-neutral-800">
            {log.map((a) => (
              <div key={a.id} className="px-6 py-3 flex items-center justify-between text-sm" data-testid={`activity-${a.id}`}>
                <span>{a.action}</span>
                <span className="text-brand-ink/40 dark:text-white/40">{a.admin} · {new Date(a.at).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <p className="mt-4 text-xs text-brand-ink/40 dark:text-white/40">2FA, granular staff roles and downloadable backups are on the roadmap.</p>
    </div>
  );
}
